RivalIQ.module('export.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Exports = RivalIQ.data.CacheLayer.extend({
        name: 'Exports',
        cacheKeys: [
            'landscapeId',
            'reportScheduleId'
        ],

        loadData: function (attributes) {
            const exports = new RivalIQ.export.collections.Exports();
            exports.landscapeId = attributes.landscapeId;

            if (_.exists(attributes.reportScheduleId)) {
                exports.reportScheduleId = attributes.reportScheduleId;
            }

            const deferred = new $.Deferred();
            exports.fetch(attributes)
                .done(_.partial(deferred.resolve, exports))
                .fail(deferred.reject);

            return deferred;
        },

        fetch: function (attributes) {
            const me = this;

            _.defaults(attributes, {
                landscapeId: RivalIQ.state.view.get('landscapeId')
            });

            return me.getOrLoad(attributes);
        },

        add: function (model) {
            const me = this;

            me.addModel(model, {
                landscapeId: RivalIQ.state.view.get('landscapeId')
            });
        }
    });

    data.exports = new Exports();
});
